var _rect, _rect2, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 39,
    viewBox: "0 0 45 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 39,
    rx: 7,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 39,
    rx: 7,
    fill: "url(#paint0_linear_377_102)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1079 15.5029V10H11V27.9467H18.1079V22.4438L13.7211 18.9734L18.1079 15.5029Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7184 10H25.0225L19.5985 14.3239L18.1079 15.5029V22.4438L19.5985 23.6228L25.0225 27.9467H35.7184L24.5603 18.9734L35.7184 10Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_377_102",
    x1: 45,
    y1: 13.4691,
    x2: 0.0570283,
    y2: 19.8986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#095BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2894,
    stopColor: "#2844C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9187,
    stopColor: "#7608D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#8000D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMenu);
export default __webpack_public_path__ + "static/media/Logo--menu.a883abb7ac671afc32ca8f64680da3a3.svg";
export { ForwardRef as ReactComponent };